<app-menu-toggle
  tooltip="Create shareable link"
  icon="share"
  [active]="false"
  (click)="openShareLinkDialog()"
>
</app-menu-toggle>
